export enum ToastVariant {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export const TOAST_DURATION = {
  DEFAULT: 5000, // 5 seconds
  ANIMATION_DELAY: 300,
  PROGRESS_UPDATE_INTERVAL: 100,
} as const;
